import { DataCard } from "./DataCard";
import React from "react";

export const LoanTypeGrid = ({
  quotes,
  loanTerm,
  isComparedIds,
  setComparedId,
  armFixedTermYears,
  setDetails,
}) => {
  return (
    <>
      <div className="thirty-year-fixed-heading bold">
        {!armFixedTermYears
          ? `${loanTerm} Year Fixed`
          : `${armFixedTermYears}/6 Adjustable Rate`}
      </div>
      <div className="data-cards">
        {quotes.map((quote) => {
          return (
            <DataCard
              quote={quote}
              key={quote.id}
              isComparedIds={isComparedIds}
              setComparedId={setComparedId}
              setDetails={setDetails}
            />
          );
        })}
      </div>
    </>
  );
};
